// PageDescription: FAQ 리스트 페이지
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

import DefaultLayout from '@/components/layouts/DefaultLayout';
import FaqTemplate from '@/components/templates/communication/Faq/FaqTemplate';
import { Urls } from '@/constants/url';
import useFaqViewModel from '@/hooks/faq/useFaqViewModel';
import useGetMagazinesInfiniteQuery from '@/hooks/magazine/mobile/useGetMagazinesInfiniteQuery';
import { CustomPageProps } from '@/types/app';
import { MagazineType } from '@/types/magazine';

const FaqPage = ({ client }: CustomPageProps) => {
  const viewModel = useFaqViewModel();
  return (
    <>
      <NextSeo
        title="1분 FAQ - 닥터나우"
        description="건강에 대한 궁금증을 닥터나우만의 전문 콘텐츠로 해결해 보세요."
        openGraph={{
          title: '건강 매거진 - 닥터나우',
          description: '건강 궁금증을 닥터나우 콘텐츠로 해결해 보세요.',
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${Urls.Magazine}}`,
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_MAGAZINE_OG_IMAGE}`,
              alt: 'Og Image Alt',
            },
          ],
        }}
        canonical="https://doctornow.co.kr/content/faq"
      />
      <FaqTemplate client={client} viewModel={viewModel} />
    </>
  );
};

FaqPage.layout = DefaultLayout;
export default FaqPage;

export const getServerSideProps: GetServerSideProps = async () => {
  const FAQ_SIZE = 20;
  const queryClient = new QueryClient();

  await useGetMagazinesInfiniteQuery.prefetchQuery(queryClient, {
    magazineCursorPageRequestInput: {
      size: FAQ_SIZE,
      contentType: MagazineType.FAQ,
    },
  });

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
